import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectOptimumMedicalBenefitsTugo = (state) => state.get('optimumMedicalBenefitsTugo');

const makeSelectOptimumMedicalBenefitsTugo = () => createSelector(
  selectOptimumMedicalBenefitsTugo,
  (optimumMedicalBenefitsTugoState) => ({

    whatExpensesAreYouClaimingFor: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'whatExpensesAreYouClaimingFor']),
      []
    ),

    // Doctor's Visit selectors
    infoOutpatientPhysicianFeesItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoOutpatientPhysicianFeesItems']),
      []
    ),

    // Diagnostic Tests
    infoDiagnosticTestsItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoDiagnosticTestsItems']),
      []
    ),

    // Prescription Drugs
    infoPrescriptionDrugsItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoPrescriptionDrugsItems']),
      []
    ),

    // Ambulance Services
    ambulanceGroundService: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'ambulanceGroundService']),
      ''
    ),
    ambulanceAirService: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'ambulanceAirService']),
      ''
    ),
    infoGroundAmbulanceItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoGroundAmbulanceItems']),
      []
    ),
    infoAirAmbulanceItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoAirAmbulanceItems']),
      []
    ),
    infoOtherAmbulanceItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoOtherAmbulanceItems']),
      []
    ),

    // Hospitalization
    hospitalizationHospitalFees: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'hospitalizationHospitalFees']),
      false
    ),
    hospitalizationInpatientPhysicianFees: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'hospitalizationInpatientPhysicianFees']),
      false
    ),
    hospitalizationXrayLabsDiagnostics: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'hospitalizationXrayLabsDiagnostics']),
      false
    ),
    hospitalizationEmergencyAirTransportation: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'hospitalizationEmergencyAirTransportation']),
      false
    ),
    hospitalizationAirfareReturnHome: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'hospitalizationAirfareReturnHome']),
      false
    ),
    hospitalizationFamilyTransportation: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'hospitalizationFamilyTransportation']),
      false
    ),
    hospitalizationFamilyTransportationMealsAccommodation: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'hospitalizationFamilyTransportationMealsAccommodation']),
      false
    ),
    hospitalizationMedicalAttendant: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'hospitalizationMedicalAttendant']),
      false
    ),
    hospitalizationReturnOfTravellingCompanion: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'hospitalizationReturnOfTravellingCompanion']),
      false
    ),
    hospitalizationOutOfPocketExpenses: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'hospitalizationOutOfPocketExpenses']),
      false
    ),
    hospitalizationReturnToUSA: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'hospitalizationReturnToUSA']),
      false
    ),
    hospitalizationEscortOfChildren: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'hospitalizationEscortOfChildren']),
      false
    ),
    hospitalizationReturnOfVehicle: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'hospitalizationReturnOfVehicle']),
      false
    ),
    hospitalizationOtherRelated: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'hospitalizationOtherRelated']),
      false
    ),
    infoHospitalFeesItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoHospitalFeesItems']),
      []
    ),
    infoInpatientPhysicianFeesItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoInpatientPhysicianFeesItems']),
      []
    ),
    infoXrayLabsDiagnosticsItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoXrayLabsDiagnosticsItems']),
      []
    ),
    infoEmergencyAirTransportationItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoEmergencyAirTransportationItems']),
      []
    ),
    infoAirfareReturnHomeItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoAirfareReturnHomeItems']),
      []
    ),
    infoFamilyTransportationItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoFamilyTransportationItems']),
      []
    ),
    infoFamilyTransportationMealsAccommodationItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoFamilyTransportationMealsAccommodationItems']),
      []
    ),
    infoMedicalAttendantItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoMedicalAttendantItems']),
      []
    ),
    infoReturnOfTravellingCompanionItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoReturnOfTravellingCompanionItems']),
      []
    ),
    infoOutOfPocketExpensesItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoOutOfPocketExpensesItems']),
      []
    ),
    infoReturnToUSAItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoReturnToUSAItems']),
      []
    ),
    infoEscortOfChildrenItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoEscortOfChildrenItems']),
      []
    ),
    infoReturnOfVehicleItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoReturnOfVehicleItems']),
      []
    ),
    returnOfVehicleCommercialAgency: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'returnOfVehicleCommercialAgency']),
      false
    ),
    returnOfVehicleFamilyMemberFriend: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'returnOfVehicleFamilyMemberFriend']),
      false
    ),
    infoReturnOfVehicleCommercialAgencyItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoReturnOfVehicleCommercialAgencyItems']),
      []
    ),
    infoReturnOfVehicleFamilyMemberFriendItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoReturnOfVehicleFamilyMemberFriendItems']),
      []
    ),

    // Essential Medical Equipment
    infoEssentialMedicalEquipmentItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoEssentialMedicalEquipmentItems']),
      []
    ),

    // Private Duty Nursing
    infoPrivateDutyNursingItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoPrivateDutyNursingItems']),
      []
    ),

    // Accidental Death and Dismemberment Benefits
    infoAccidentalDeathAndDismembermentItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoAccidentalDeathAndDismembermentItems']),
      []
    ),

    // Expenses Related to Death
    expensesRelatedToDeathReturnRemains: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'expensesRelatedToDeathReturnRemains']),
      false
    ),
    expensesRelatedToDeathBurialCremation: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'expensesRelatedToDeathBurialCremation']),
      false
    ),
    expensesRelatedToDeathFamilyTransportation: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'expensesRelatedToDeathFamilyTransportation']),
      false
    ),
    infoExpensesRelatedToDeathReturnRemainsItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoExpensesRelatedToDeathReturnRemainsItems']),
      []
    ),
    infoExpensesRelatedToDeathBurialCremationItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoExpensesRelatedToDeathBurialCremationItems']),
      []
    ),
    infoExpensesRelatedToDeathFamilyTransportationItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoExpensesRelatedToDeathFamilyTransportationItems']),
      []
    ),

    // Dental Services
    dentalServicesDentalAccident: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'dentalServicesDentalAccident']),
      false
    ),
    dentalServicesDentalPainOther: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'dentalServicesDentalPainOther']),
      false
    ),
    infoDentalAccidentItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoDentalAccidentItems']),
      []
    ),
    infoDentalPainOtherItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoDentalPainOtherItems']),
      []
    ),

    // Professional Services
    professionalServices: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'professionalServices']),
      false
    ),
    professionalServicesPhysiotherapist: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'professionalServicesPhysiotherapist']),
      false
    ),
    professionalServicesChiropractor: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'professionalServicesChiropractor']),
      false
    ),
    professionalServicesChiropodist: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'professionalServicesChiropodist']),
      false
    ),
    professionalServicesOsteopath: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'professionalServicesOsteopath']),
      false
    ),
    professionalServicesPodiatrist: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'professionalServicesPodiatrist']),
      false
    ),
    professionalServicesAcupuncturist: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'professionalServicesAcupuncturist']),
      false
    ),
    professionalServicesOptometrist: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'professionalServicesOptometrist']),
      false
    ),
    infoPhysiotherapistItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoPhysiotherapistItems']),
      []
    ),
    infoChiropractorItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoChiropractorItems']),
      []
    ),
    infoChiropodistItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoChiropodistItems']),
      []
    ),
    infoOsteopathItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoOsteopathItems']),
      []
    ),
    infoPodiatristItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoPodiatristItems']),
      []
    ),
    infoAcupuncturistItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoAcupuncturistItems']),
      []
    ),
    infoOptometristItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoOptometristItems']),
      []
    ),
    infoOtherUnrelatedBenefitItems: mapWithDefault(
      optimumMedicalBenefitsTugoState,
      () => optimumMedicalBenefitsTugoState.getIn(['form', 'infoOtherUnrelatedBenefitItems']),
      []
    ),
  })
);

const makeSelectOptimumMedicalBenefitsTugoErrors = () => createSelector(
  selectOptimumMedicalBenefitsTugo,
  (optimumMedicalBenefitsTugoState) => mapWithDefault(
    optimumMedicalBenefitsTugoState,
    () => optimumMedicalBenefitsTugoState.get('errors'),
    []
  )
);

export {
  makeSelectOptimumMedicalBenefitsTugo,
  makeSelectOptimumMedicalBenefitsTugoErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.OptimumMedicalBenefits/selectors.js